var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1C6.5 1 4 3.5 4 6.5c0 1.6.7 3 1.7 4C6.4 11.2 7 12 7 13c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2 0-1 .6-1.8 1.3-2.5 1-1 1.7-2.4 1.7-4 0-3-2.5-5.5-5.5-5.5h-1zm0 3c0-.6.4-1 1-1C12.4 3 14 4.6 14 6.5c0 .6-.4 1-1 1s-1-.4-1-1c0-.8-.7-1.5-1.5-1.5-.6 0-1-.4-1-1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H8z"
  })));
};
export default SvgLightBulb;